export function formatDate(dateString: string, locale?: string): string {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  const intlLocale = locale === 'km' ? 'km-KH' : 'en-US';
  return new Date(dateString).toLocaleDateString(intlLocale, options);
}
